import messages from './cmsSchedule.json' with { type: 'json' };

export const cmsScheduleEn: Readonly<typeof messages> = messages;
